import { useEffect, useLayoutEffect } from 'react';

import { isClient } from '@/utils/isClientOrServer';

/**
 * Like `useLayoutEffect`, but avoids React’s SSR warning: `useLayoutEffect` does not run on
 * the server, so we delegate to `useEffect` there (neither runs during render; behavior stays
 * client-first for layout-timing work).
 */
export const useIsomorphicLayoutEffect = isClient ? useLayoutEffect : useEffect;
